'use strict'

/* eslint-disable camelcase */
const binaries_by_id = [ // 52
  0x1,  0x1,  0x1,  0x1,
  0x2,  0x2,  0x2,  0x2,
  0x4,  0x4,  0x4,  0x4,
  0x8,  0x8,  0x8,  0x8,
  0x10, 0x10, 0x10, 0x10,
  0x20, 0x20, 0x20, 0x20,
  0x40, 0x40, 0x40, 0x40,
  0x80, 0x80, 0x80, 0x80,
  0x100,  0x100,  0x100,  0x100,
  0x200,  0x200,  0x200,  0x200,
  0x400,  0x400,  0x400,  0x400,
  0x800,  0x800,  0x800,  0x800,
  0x1000, 0x1000, 0x1000, 0x1000
]

const suitbit_by_id = [ // 52
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200,
  0x1,  0x8,  0x40, 0x200
]

exports.binaries_by_id = binaries_by_id
exports.suitbit_by_id = suitbit_by_id
